(function() {
  // Match a card's variant-title exactly against the toggle's target size.
  // Variant titles ("8", "16")
  // Titles may also be multi-option (e.g. "Black / 8"); we split on "/", compare whole tokens so those still match correctly.
  function cardMatchesSize(card, targetSize) {
    const inners = card.querySelectorAll('.product-item__bg__inner');
    for (const inner of inners) {
      const title = inner.getAttribute('data-variant-title') || '';
      const tokens = title.split('/').map(t => t.trim());
      if (tokens.includes(targetSize)) return inner;
    }
    return null;
  }

  function applyToCard(card, targetSize) {
    const defaultFigure = card.querySelector('[data-product-image-default] figure');
    const allVariantInners = card.querySelectorAll('.product-item__bg__inner');

    // Reset every variant inner to hidden first
    allVariantInners.forEach(inner => {
      inner.style.setProperty('display', 'none', 'important');
      inner.style.setProperty('opacity', '0', 'important');
      inner.style.setProperty('visibility', 'hidden', 'important');
    });

    if (targetSize === 'default') {
      if (defaultFigure) {
        defaultFigure.style.setProperty('opacity', '1', 'important');
        defaultFigure.style.setProperty('visibility', 'visible', 'important');
      }
      return;
    }

    const specificInner = cardMatchesSize(card, targetSize);

    if (specificInner) {
      // Hide default, show the matching size image
      if (defaultFigure) {
        defaultFigure.style.setProperty('opacity', '0', 'important');
        defaultFigure.style.setProperty('visibility', 'hidden', 'important');
      }
      specificInner.style.setProperty('display', 'block', 'important');
      specificInner.style.setProperty('opacity', '1', 'important');
      specificInner.style.setProperty('visibility', 'visible', 'important');
    } else if (defaultFigure) {
      // Fallback: product has no image for this size, keep the default
      defaultFigure.style.setProperty('opacity', '1', 'important');
      defaultFigure.style.setProperty('visibility', 'visible', 'important');
    }
  }

  // scope: optional array/NodeList of specific cards to update.
  // Omit to sweep the whole grid.
  function updateModelImages(targetSize, cards) {
    const list = cards || document.querySelectorAll('[data-grid-item]');
    list.forEach(card => applyToCard(card, targetSize));
  }

  function getCurrentSize() {
    const activeBtn = document.querySelector('.btn--model-toggle.active');
    return activeBtn ? activeBtn.getAttribute('data-toggle-size') : 'default';
  }

  // --- Button clicks -------------------------------------------------------
  const trackWrapper = document.getElementById('CollectionModelToggleWrapper');
  if (trackWrapper) {
    trackWrapper.addEventListener('click', function(e) {
      const btn = e.target.closest('.btn--model-toggle');
      if (!btn || btn.classList.contains('active')) return;

      document.querySelectorAll('.btn--model-toggle').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      updateModelImages(btn.getAttribute('data-toggle-size'));
    });
  }

  // --- Pagination handling -------------------------------------------------
  // Collect only grid items inside an added node (or the node itself)
  function extractCards(node) {
    if (node.nodeType !== 1) return [];
    if (node.matches?.('[data-grid-item]')) return [node];
    return node.querySelector?.('[data-grid-item]')
      ? Array.from(node.querySelectorAll('[data-grid-item]'))
      : [];
  }

  // Infinite scroll / "load more": watch for newly injected cards and
  // apply the active size to only those cards.
  function observeGrid() {
    const firstItem = document.querySelector('[data-grid-item]');
    if (!firstItem) return;

    // Scope the observer to the Shopify section, not document.body
    const root =
      firstItem.closest('[data-section-id]') ||
      firstItem.closest('.collection') ||
      firstItem.closest('main') ||
      document.body;

    let queued = [];
    let scheduled = false;

    const flush = () => {
      scheduled = false;
      const size = getCurrentSize();
      if (size !== 'default' && queued.length) {
        updateModelImages(size, queued);
      }
      queued = [];
    };

    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          const found = extractCards(node);
          if (found.length) queued.push(...found);
        }
      }

      if (queued.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  // Filter / sort: Broadcast swaps the whole grid and fires this event.
  document.addEventListener('shopify:section:load', () => {
    const size = getCurrentSize();
    if (size !== 'default') {
      requestAnimationFrame(() => updateModelImages(size));
    }
  });

  // --- Init ----------------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGrid);
  } else {
    observeGrid();
  }
})();